export default __webpack_public_path__ + "static/media/timeSign.5b35c4ef.svg";